import React, { Component } from 'react'	

 class MultiSelect extends Component {	
  constructor(props) {	
    super(props);	
    this.state = {	
      list: [],	
      modalOpen: false,	
      selectedValue: [],	
      displayValue: ''	
    }	
    this.wrapperRef=null;	
    this.handleCheckBox = this.handleCheckBox.bind(this);	
    this.handleClickOutside=this.handleClickOutside.bind(this);	
  }	

   componentWillReceiveProps(nextProps) {
    if (nextProps === undefined || nextProps === null) {
      return;
    }
      let list = [...nextProps.options].sort((a, b) => a.value.localeCompare(b.value));	

       const selectedValue = [...nextProps.value];	
      list = list.map(l => {	
        return Object.assign({}, l, { isChecked: false });	
      })	
      selectedValue.forEach(sv => {	
        const selectedList = list.find((l) => l.value.split('-')[0] === sv.value.split('-')[0]);	
        if (selectedList) {	
          list[list.indexOf(selectedList)].isChecked = true;	
        }	
      })	
      const displayValue = nextProps.value.length === 1 ?	
        nextProps.value[0].value.split('-')[0] : nextProps.value.length + ' selected';	
      this.setState({	
        list,	
        selectedValue,	
        displayValue	
      })	

     document.addEventListener('mousedown',this.handleClickOutside);	
  }	

   componentWillUnmount(){	
    document.removeEventListener('mousedown',this.handleClickOutside)	
  } 

   handelModel() {	
    const modalOpen = this.state.modalOpen;	
    this.setState({	
      modalOpen: !modalOpen	
    });	
  }	

   handleCheckBox(item) {	
    let selectedValue = this.state.selectedValue;	
    let selectedItem=selectedValue.find((sv)=>sv.value.split('-')[0]===item.value.split('-')[0]);	
    if (selectedItem) {	
      const index = selectedValue.indexOf(selectedItem);	
      if (index !== -1) {	
        selectedValue.splice(index, 1)	
      }	
    } else {	
      selectedValue.push(item);	
    }	

     let list = this.state.list;	
    list = list.map(l => {	
      if (l == item) {	
        l.isChecked = !l.isChecked;	
      }	
      return l;	
    });	
    const displayValue = selectedValue.length === 1 ? selectedValue[0].value.split('-')[0] : selectedValue.length + ' selected';	
    this.setState({	
      selectedValue,	
      list,	
      displayValue	
    })	
    const eventToSend = this.props.options.filter((opt) => {	
      return !!list.find(l => l.value.split('-')[0] === opt.value.split('-')[0] && l.isChecked);	
    });	
    this.props.onChange(eventToSend);	
  }	
  handleClickOutside(event){
    if(this.wrapperRef&&!this.wrapperRef.contains(event.target)){	
      this.setState({	
        modalOpen: false	
      });	
    }	
  }	
  render() {	
    const { list, modalOpen, displayValue } = this.state;

    const clearFlag = this.state.selectedValue && this.state.selectedValue.map((acc) => {
      const key = this.props.options.reduce((j, i) => {
        const k = (i.value.split('-')[0]).indexOf(acc.value.split('-')[0]) !== -1 ? true : false
        return (k || j)
      }, false)

      if (!key) this.handleCheckBox(acc);
    });

    const selectedList = this.state.selectedValue.map(val => val.value);
    return (	
      <div ref={instance=>this.wrapperRef=instance}>	
      <div className="customSelectBox" onClick={this.handelModel.bind(this)}>	
        <label>{displayValue}</label>        	
        </div>	
        {modalOpen &&	
          <div className='customSelectBoxList'>	
            <ul>	
              {list.map((l, idx) => {	
                return (	
                  <li key={idx}
                  style={{alignItems:'center'}}>	
                    <input type="checkbox" 
                            style = {{marginBottom:'5px'}} 
                      defaultChecked={l.isChecked} onClick={() => this.handleCheckBox(l)}
                      disabled ={selectedList.includes(l.mutuallyExclusive)}
                       />	
                    {l.label}	
                  </li>)	
              })}	
            </ul>	
          </div>	
        }	
      </div>	
    )	
  }	
}	

 export default MultiSelect; 